import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

import { BASE_STYLES } from '../utils/constants';

export const WelcomeContainer = superstyled({
  name: 'AssistantWelcome',
  slot: 'Container',
  tag: Box,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: 'auto',
    maxWidth: '35rem',
    height: 'calc(100dvh - 2rem)'
  })
});

export const WelcomeHeader = superstyled({
  name: 'AssistantWelcome',
  slot: 'Header',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.border.light}`,
    backgroundColor: theme.palette.background.paper,
    minHeight: theme.spacing(8)
  })
});

export const LogoContainer = superstyled({
  name: 'AssistantWelcome',
  slot: 'LogoContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
});

export const WelcomeContent = superstyled({
  name: 'AssistantWelcome',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    height: '100%',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 3),
    textAlign: 'center',
    overflow: 'auto'
  })
});

export const WelcomeTitle = superstyled({
  name: 'AssistantWelcome',
  slot: 'Title',
  tag: Box,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(4),
    maxWidth: '35rem'
  })
});

export const WelcomeTitleText = superstyled({
  name: 'AssistantWelcome',
  slot: 'TitleText',
  tag: Text,
  styles: () => ({
    fontWeight: 600
  })
});

export const PromptButton = superstyled({
  name: 'AssistantWelcome',
  slot: 'Button',
  tag: Button,
  styles: ({ theme }) => ({
    ...BASE_STYLES,
    width: '100%',
    padding: theme.spacing(2, 1.5),
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: theme.shadows[2],
      border: `1px solid ${theme.palette.border.light}`,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary
    }
  })
});

export const PromptsContainer = superstyled({
  name: 'AssistantWelcome',
  slot: 'PromptsContainer',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(2),
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(1, 1fr)'
    },
    '& > button': {
      justifyContent: 'flex-start',
      textAlign: 'left',
      padding: theme.spacing(2, 3),
      borderRadius: theme.shape.borderRadius,
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: theme.shadows[2]
      }
    }
  })
});

export const WelcomeInputArea = superstyled({
  name: 'AssistantWelcome',
  slot: 'InputArea',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: '37.5rem',
    width: 'min(100vw - 2rem, 37.5rem)',
    margin: '0 auto',
    zIndex: 10,
    position: 'sticky',
    bottom: 0,
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(2)
  })
});
